import CryptoJS from 'crypto-js';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default function useDecryptParam(paramName = 'id') {
  const route = useRoute();

  const decryptedValue = computed(() => {
    const encrypted = route.params[paramName];
    if (!encrypted) return null;

    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, process.env.VUE_APP_ENCRYPT_SECRET_KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (err) {
      console.error('Decryption failed:', err);
      return null;
    }
  });

  return {
    decryptedValue
  };
}
